import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsMgmtRoutingModule } from './components-mgmt-routing.module';
import { ComponentsListComponent } from './components-list/components-list.component';
import { AddComponentsComponent } from './add-components/add-components.component';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {IconsModule} from '../../icons/icons.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {TableModule} from 'src/app/table/table.module';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorModule} from 'src/app/components/error/error.module';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {ConfirmationDialogModule} from 'src/app/components/confirmation-dialog/confirmation-dialog.module';
import { AdditionalCapabilityModule } from 'src/app/components/additional-capability/additional-capability.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';

@NgModule({
  declarations: [
    ComponentsListComponent,
    AddComponentsComponent
  ],
  imports: [
    CommonModule,
    ComponentsMgmtRoutingModule,
    IconsModule,
    ToolbarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    TableModule,
    PaginatorModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule,
    SidenavHeaderModule,
    SharedModule,
    MatDividerModule,
    ConfirmationDialogModule,
    SearchFilterModule,
    AdditionalCapabilityModule
  ]
})
export class ComponentsMgmtModule { }
